import auth from '../auth';

export const USER_ACTIONS = {
    LOGIN: 'user/ADD',
    UPDATE: 'user/UPDATE',
    LOGOUT: 'user/REMOVE',
};

const reducer = (state = auth.getUser(), action) => {
    const { type, payload } = action;

    switch (type) {
        case USER_ACTIONS.LOGIN:
        case USER_ACTIONS.UPDATE:
            return payload;
        case USER_ACTIONS.LOGOUT:
            return null;
        default:
            return state;
    }
};

export default reducer;



/** WEBPACK FOOTER **
 ** ../src/dash/front/reducers/user.js
 **/